/**
 * @return {Object} // theInitialTheme contains all theme options. Just copy/paste from the cashiers initial theme object.
 */
export const theInitialTheme = () => ({
  input: {
    color: '#5b5b5b',
    fontSize: '14px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    height: '52px',
    borderRadius: '2px'
  },
  inputbackground: {
    color: '#ffffff'
  },
  labels: {
    color: '#5b5b5b',
    fontSize: '13px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    background: '#f4f4f4'
  },
  logo: {
    width: '90px'
  },
  headings: {
    color: '#000000',
    fontSize: '14px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'bold',
    lineHeight: 'normal'
  },
  loader: {
    color: '#cccccc'
  },
  error: {
    color: '#ff2e56'
  },
  warning: {
    color: '#FFDA47'
  },
  warningbackground: {
    color: '#ffae0a'
  },
  success: {
    color: '#4BB543'
  },
  buttons: {
    color: '#46beab'
  },
  headerbackground: {
    color: '#ffffff'
  },
  background: {
    color: '#ffffff'
  },
  cashierbackground: {
    color: '#ffffff'
  },
  cardbackground: {
    color: 'transparent'
  },
  border: {
    radius: '3px'
  },
  margin: {
    size: '14px'
  },
  providerlogos: {
    list: '38px',
    dropdown: '26px'
  },
  accountlogos: {
    dropdown: '34px'
  },
  creditcardicons: {
    creditcardUrl: 'default',
    cvvUrl: 'default',
    expirydateUrl: 'default'
  },
  layout: {
    mainContainerTopDown: '20px',
    mainContainerSide: '15px',
    footerHeight: '55px'
  }
})
